
<div class="loaderDiv" *ngIf="isLoading">
<div class="custom-loader "></div>
</div>

